import React, { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/**
 * LiveClock — Sağ üst köşede canlı Türkiye saati göstergesi.
 * Her saniye Europe/Istanbul (UTC+3) TZ'e göre yenilenir. Kullanıcının
 * tarayıcı TZ'i farklı bile olsa doğru TR saatini görür.
 */
export default function LiveClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const timeStr = now.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "Europe/Istanbul" });
  const dateStr = now.toLocaleDateString("tr-TR", { day: "2-digit", month: "short", weekday: "short", timeZone: "Europe/Istanbul" });
  return (
    <div
      title="Türkiye (Europe/Istanbul) saat dilimi — canlı"
      data-testid="live-clock"
      className="inline-flex items-center gap-1.5 border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/70 rounded-md px-2 py-1"
    >
      <Clock size={12} className="text-indigo-500 dark:text-indigo-300"/>
      <span className="text-[10px] uppercase font-semibold text-slate-500 dark:text-slate-400 hidden xl:inline">TR</span>
      <span className="text-xs font-mono font-semibold text-slate-800 dark:text-slate-100 tabular-nums" data-testid="live-clock-time">{timeStr}</span>
      <span className="text-[10px] text-slate-400 dark:text-slate-500 hidden lg:inline" data-testid="live-clock-date">{dateStr}</span>
    </div>
  );
}
